import { defineStore } from "pinia";

import { CommunicationType } from "@/enums/communicationLogs";
import communicationService from "@/services/modules/communication";

import type { IResponseLinks, IResponseMeta } from "@/models/common";
import type { NoteLog } from "@/models/communicationLogs";
import type { Note, NoteFilterParams, NotesResource } from "@/models/notes";

interface UseNotesState {
  currentNotes: NotesResource;
  activeNoteDealId: string | null;
  activeNoteBusinessDealId: number | null;
  isDealActivityPipModeActivated: boolean;
}
const getDefaultState = (): UseNotesState => ({
  currentNotes: {
    data: [],
    meta: {} as IResponseMeta,
    links: {} as IResponseLinks,
  },
  activeNoteDealId: null,
  activeNoteBusinessDealId: null,
  isDealActivityPipModeActivated: false,
});

const useNotesStore = defineStore("notes", {
  state: getDefaultState,
  actions: {
    async getNotes(params: NoteFilterParams) {
      const applicationIds =
        this.isDealActivityPipModeActivated && this.activeNoteDealId
          ? [this.activeNoteDealId]
          : params.application_ids;

      const response = await communicationService.getCommunicationList({
        type: CommunicationType.note,
        application_ids: applicationIds,
        page: params.page?.toString(),
        per_page: params.per_page?.toString(),
        search: params.search,
      });

      this.currentNotes = {
        data: (response.data as NoteLog[]).map((log) => log.data as Note),
        meta: response.meta,
        links: {} as IResponseLinks,
      };
    },
    resetNotes() {
      if (this.isDealActivityPipModeActivated) {
        return;
      }
      this.currentNotes = getDefaultState().currentNotes;
    },

    getNotableId(notableId: string | number | undefined) {
      if (!this.isDealActivityPipModeActivated) {
        return notableId;
      }

      return (
        this.activeNoteBusinessDealId ?? this.activeNoteDealId ?? undefined
      );
    },
  },
});

export default useNotesStore;
